module.exports = __webpack_public_path__ + "components/rewards/intersport/static/icon-2f3a83ff0de8a999dae53ed0dbdf9f67.svg";